'use client';

import { type Dispatch, type SetStateAction, createContext, useContext } from 'react';
export type Algorithms = 'linear' | 'ease-out-sine';
type ProgressContextT = {
  percent: number;
  total: number;
  algorithm: Algorithms;
  setCurrent: Dispatch<SetStateAction<number>>;
};
export const ProgressContext = createContext<ProgressContextT | undefined>(undefined);